import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  FaHome,
  FaTasks,
  FaUser,
  FaUserShield,
  FaSignInAlt,
  FaUserPlus,
  FaMoneyBillWave,
  FaBars,
  FaTimes,
} from "react-icons/fa";

export default function Sidebar() {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const linkClasses = (path) =>
    `flex items-center gap-3 px-4 py-2 rounded-lg transition ${
      location.pathname === path
        ? "bg-blue-600 text-white shadow-md"
        : "text-gray-300 hover:bg-gray-700 hover:text-white"
    }`;

  const toggleSidebar = () => setIsOpen(!isOpen);

  return (
    <>
      {/* Toggle Button */}
      <button
        className="fixed scroll top-20 left-4 z-40 p-2 rounded-md bg-blue-600 text-white md:hidden"
        onClick={toggleSidebar}
        aria-label="Toggle Sidebar"
      >
        {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Sidebar */}
      <div
        className={`
          fixed top-0 left-0 h-full bg-gray-900 text-white shadow-lg
          w-64 transform transition-transform duration-300 ease-in-out
          z-50
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0 md:static md:flex md:flex-col
        `}
      >
        <div className="px-6 py-4 border-b border-gray-700">
          <h2 className="text-2xl font-bold text-blue-400 tracking-wide">
            ⚡ DSABuddy
          </h2>
        </div>

        <ul className="flex-grow p-4 space-y-3">
          {user ? (
            <>
              <li>
                <Link
                  to="/dashboard"
                  className={linkClasses("/dashboard")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaHome /> Dashboard
                </Link>
              </li>
              <li>
                <Link
                  to="/solve"
                  className={linkClasses("/solve")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaTasks /> Solve Question
                </Link>
              </li>
              <li>
                <Link
                  to="/profile"
                  className={linkClasses("/profile")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaUser /> Profile
                </Link>
              </li>
              <li>
                <Link
                  to="/history"
                  className={linkClasses("/history")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaMoneyBillWave /> Transaction
                </Link>
              </li>
              {user.role === "Admin" && (
                <li>
                  <Link
                    to="/admin"
                    className={linkClasses("/admin")}
                    onClick={() => setIsOpen(false)}
                  >
                    <FaUserShield /> Admin Panel
                  </Link>
                </li>
              )}
            </>
          ) : (
            <>
              <li>
                <Link
                  to="/login"
                  className={linkClasses("/login")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaSignInAlt /> Login
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className={linkClasses("/register")}
                  onClick={() => setIsOpen(false)}
                >
                  <FaUserPlus /> Register
                </Link>
              </li>
            </>
          )}
        </ul>

        <div className="px-6 py-4 border-t border-gray-700 text-sm text-gray-400">
          © {new Date().getFullYear()} DSA Platform
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-40 md:hidden"
          onClick={toggleSidebar}
          aria-hidden="true"
        ></div>
      )}
    </>
  );
}
